import { Provider } from '@angular/core'
import { metaTagsToken } from 'shared-components'

export const playMetaTagsProvider: Provider = {
  provide: metaTagsToken,
  useValue: [{ name: 'robots', content: 'noindex,nofollow' }],
}
